import { useMutation } from "@tanstack/react-query";
import { deleteMatrixColumn } from "@/domains/matrix";
import { useMatrixInvalidation } from "./use-matrix-invalidation";

export function useDeleteMatrixColumn(collectionId: string) {
  const { invalidateDetailAndList } = useMatrixInvalidation(collectionId);

  return useMutation({
    mutationFn: (columnKey: string) =>
      deleteMatrixColumn(collectionId, columnKey),
    onSuccess: invalidateDetailAndList,
  });
}
